export default "__VITE_ASSET__a5119e9e__"